import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Paper,
    withStyles,
    Typography,
    Grid,
    IconButton,
    Table,
    TableRow,
    TableCell,
    Fade,
    TableHead,
    TableBody,
    Button
} from "@material-ui/core";
import { Modal, Progress } from "reactstrap";
import {
    selectQualificationsByCategory,
    selectViewCategoryDetailModalInfo,
    selectQualificationsInCategory,
    selectFilteredUsers
} from "./selectors";

import {
    getAllUsers,
    getQualificationCategories,
    getRequiredQualifications,
    setViewQualCategoryDetail
} from "./actions";
import _ from "lodash";
import { Doughnut } from "react-chartjs-2";
import MasonryLayout from "react-masonry-layout";
import AddIcon from "@material-ui/icons/RemoveRedEye";
import moment from "moment";
const styles = () => ({
    titlePaper: {
        width: "fit-content",
        marginBottom: "25px",
        padding: "20px",
        border: "0px solid black"
    },
    modalStyle: {
        width: "fit-content",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -0)"
    }
});
class QualificationsOverview extends Component {
    constructor(props) {
        super(props);
        props.getAllUsers();
        props.getQualificationCategories();
        props.getRequiredQualifications();
    }

    render() {
        const {
            classes,
            qualificationsPerCategory,
            viewCategoryDetailModal,
            qualificationsInCategory
        } = this.props;

        let numUsers = this.props.users === false ? 0 : Object.keys(this.props.users).length;
        let rank = 0;
        return (
            // <StyledCard>
            <div>
                <Paper className={classes.titlePaper}>
                    <Typography variant="display2"> Qualifications Overview </Typography>
                </Paper>
                <Modal
                    style={{
                        width: "fit-content"
                    }}
                    isOpen={viewCategoryDetailModal.modalOpen}
                >
                    <Paper className={classes.modalStyle}>
                        <Typography variant="headline">
                            {viewCategoryDetailModal.category} Qualification Info
                        </Typography>
                        {viewCategoryDetailModal.modalOpen && (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="body2">
                                                <b>Rank</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                <b>Name</b>
                                            </Typography>
                                        </TableCell>
                                        {Object.keys(
                                            qualificationsInCategory.qualsInCategory.qualifications
                                        ).map(e => {
                                            let qualInfo =
                                                qualificationsInCategory.qualsInCategory
                                                    .qualifications[e];

                                            return (
                                                <TableCell
                                                    style={{ padding: 5 }}
                                                    key={qualInfo.qualification_id}
                                                >
                                                    <Typography style={{ minWidth: 100 }}>
                                                        <b>{qualInfo.qualification_title}</b>
                                                    </Typography>
                                                </TableCell>
                                            );
                                        })}
                                        <TableCell>
                                            <Typography variant="body2">
                                                <b>Progression</b>
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.keys(qualificationsInCategory.qualsPerUsers).map(
                                        (e, i) => {
                                            let userInfo =
                                                qualificationsInCategory.qualsPerUsers[e];
                                            let completed = 0;
                                            let qualCount =
                                                qualificationsInCategory.qualsInCategory
                                                    .qualifications.length;

                                            rank++;
                                            return (
                                                <TableRow key={userInfo.uid}>
                                                    <TableCell>{rank}</TableCell>
                                                    <TableCell>{userInfo.name}</TableCell>
                                                    {userInfo.userQualsInCategory.map((e, i) => {
                                                        let currentDate = moment().endOf("day");

                                                        let expDate = moment(
                                                            e.qualification_exp_date,
                                                            "DD/MM/YYYY"
                                                        );

                                                        let verified =
                                                            e.qualification_verified === "Yes"
                                                                ? true
                                                                : false;

                                                        let inDate =
                                                            expDate.isAfter(currentDate) === true
                                                                ? true
                                                                : false;
                                                        let img =
                                                            (verified && inDate) === true
                                                                ? e.qualification_valid_img
                                                                : e.qualification_invalid_img;
                                                        if (inDate && verified) completed++;
                                                        return (
                                                            <TableCell key={i}>
                                                                <img
                                                                    style={{
                                                                        width: 35,
                                                                        height: 35
                                                                    }}
                                                                    src={img}
                                                                    alt="qualificationIcon"
                                                                />
                                                            </TableCell>
                                                        );
                                                    })}
                                                    <TableCell>
                                                        <Progress
                                                            value={(completed / qualCount) * 100}
                                                        />
                                                        <div className="text-center">
                                                            {Math.floor(
                                                                (completed / qualCount) * 100
                                                            )}
                                                            %
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        }
                                    )}
                                </TableBody>
                            </Table>
                        )}

                        <Button
                            color="primary"
                            variant="contained"
                            style={{
                                float: "right",
                                marginTop: "20px",
                                marginRight: "20px",
                                marginBottom: "20px"
                            }}
                            onClick={() => {
                                this.props.setViewQualCategoryDetail(false, false);
                            }}
                        >
                            Close
                        </Button>
                    </Paper>
                </Modal>
                {qualificationsPerCategory && (
                    <MasonryLayout
                        style={{ margin: "auto" }}
                        id="masonry"
                        sizes={[{ columns: 2, gutter: 20 }]}
                        
                    >
                        {qualificationsPerCategory.map((e, i) => {
                            let quals = _.get(e, "completedQuals") || [];

                            return (
                                <Fade key={i} in={true}>
                                    <Paper style={{ width: "49%", padding: "10px" }}>
                                        <div style={{ display: "flex", width: "100%" }}>
                                            <Typography variant="headline">
                                                {e.category} Qualifications
                                            </Typography>
                                            <IconButton
                                                onClick={() => {
                                                    this.props.setViewQualCategoryDetail(
                                                        e.category,
                                                        true
                                                    );
                                                }}
                                                style={{
                                                    margin: "auto",
                                                    border: "1px solid blue",
                                                    color: "blue"
                                                }}
                                            >
                                                <AddIcon />
                                            </IconButton>
                                        </div>{" "}
                                        <Typography variant="caption">
                                            {e.totalQuals} Required
                                        </Typography>
                                        <Grid container spacing={16}>
                                            {quals.map(e => {
                                                let data = {
                                                    labels: ["Valid", "Invalid"],
                                                    datasets: [
                                                        {
                                                            data: [
                                                                e.completedCount,
                                                                numUsers - e.completedCount
                                                            ],
                                                            backgroundColor: ["green", "red"],
                                                            label: "test"
                                                        }
                                                    ]
                                                };
                                                return (
                                                    <Grid key={e.qualID} item xs={4} xl={4}>
                                                        <div
                                                            style={{
                                                                position: "relative",
                                                                width: 180,
                                                                height: 180
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "43%",
                                                                    right: "42%"
                                                                }}
                                                            >
                                                                <img
                                                                    src={e.img}
                                                                    alt="Qualification Icon"
                                                                    style={{
                                                                        width: 35,
                                                                        height: 35
                                                                    }}
                                                                />
                                                                <Typography variant="caption">
                                                                    {e.completedCount}/{numUsers}
                                                                </Typography>
                                                            </div>
                                                            <Doughnut
                                                                width={170}
                                                                height={170}
                                                                data={data}
                                                                style={{ position: "absolute" }}
                                                                options={{
                                                                    maintainAspectRatio: false,
                                                                    responsive: false,
                                                                    legend: {
                                                                        display: false
                                                                    },
                                                                    tooltips: {
                                                                        enabled: true
                                                                    },
                                                                    title: {
                                                                        display: true,
                                                                        text: e.title
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>
                                    </Paper>
                                </Fade>
                            );
                        })}
                    </MasonryLayout>
                )}
            </div>
      
        );
    }
}
export default connect(
    store => {
        return {
            users: selectFilteredUsers(store),
            qualificationsPerCategory: selectQualificationsByCategory(store),
            viewCategoryDetailModal: selectViewCategoryDetailModalInfo(store),
            qualificationsInCategory: selectQualificationsInCategory(store)
        };
    },
    {
        getAllUsers,
        getQualificationCategories,
        getRequiredQualifications,
        setViewQualCategoryDetail
    }
)(withStyles(styles)(QualificationsOverview));
